import userRoles from '../defines/scope';
const {
    AuthorizedBookingSpecialist,
    EnhancedAuthorizedBookingSpecialist,
    CoBusinessSelfService,
    InflightSafetyAuditor,
    NRSA,
    NRSASupportRole,
    TravelServices,
    Leisure
} = userRoles;

export const toRedirect = (roles) => {
    if (roles.includes(Leisure)) {
        return 'air/booking/?mode=leisure';
    } else if (roles.includes(NRSA) || roles.includes(NRSASupportRole)) {
        return 'air/space-available/';
    } else if (
        roles.includes(CoBusinessSelfService) ||
        roles.includes(TravelServices) ||
        roles.includes(EnhancedAuthorizedBookingSpecialist) ||
        roles.includes(AuthorizedBookingSpecialist) ||
        roles.includes(InflightSafetyAuditor)
    ) {
        return 'air/booking/';
    } else {
        return null;
    }
};
